// window.cateData.isShowLoading = true; //页面需要loading加载数据
var campaignPagenewServerModule = {
    footerCon: null, // 底部悬浮
    tabCon: null, // Tab容器
    tabList: null, // 所有的tab标签
    checkMoreList: null, // 所有查看更多
    clsoeMoreList: null, // 所有关闭更多
    tabConTop: 0, // Tab容器距离顶部距离
    header: null, // 网站顶部
    isScrolling: false, // 是否正在滚动
    secondTabList: null,
    secondTabConList: null,
    curShowCount: 4,
    dialogBoxEl: document.querySelector('.new-server-suanli-dialog'), //弹窗

    init: function () {
        this.tabCon = document.querySelector('.new-server-tab-container');
        this.footerCon = document.querySelector('.new-server-footer');
        this.tabConTop = this.tabCon.offsetTop;
        this.tabList = document.querySelectorAll('.new-server-tabs a');
        this.checkMoreList = document.querySelectorAll(common.isM ? '.product-item-check-more' : '.new-server-product-item-more');
        this.clsoeMoreList = document.querySelectorAll('.new-server-close-icon');
        this.header = document.querySelector(common.isM ? '.topbar' : '.navBox');
        this.initTab();
        this.initForm();
        this.initCheckMore();
    },

    /* 初始化页面逻辑 */
    initForm: function () {
        $('.customer-service-popup .customer-service-info').text("戴尔科技新一代全能型PowerEdge服务器上市！了解更多产品和优惠详情，可咨询在线客服或拨打400-884-6610");
        $('#smart-bargain-form .m-bargain-header h4').text("产品咨询意向单");
        $('#smart-bargain-form .dialog-content .bargain-title').text("产品咨询意向单");
        smartFormDialog.formId = 2302211768144080;
        smartFormDialog.init();
        // msg.ProjectConsultingDialog = function () {
        //     smartFormDialog.showDialog();
        // }
    },
    /* 初始化Tab */
    initTab: function () {
        var _this = this;
        for (var idx = 0; idx < _this.tabList.length; idx++) {
            _this.tabList[idx].index = idx;
            _this.tabList[idx].onclick = function () {
                var target = document.getElementById(this.hash.slice(1));
                if (!target) return;
                for (var k = 0; k < _this.tabList.length; k++) {
                    _this.tabList[k].parentElement.classList.remove('active-tab');
                }
                this.parentElement.classList.add('active-tab');

                var targetOffsetTop = target.offsetTop - _this.header.offsetHeight - _this.tabCon.offsetHeight;

                if (!_this.tabCon.classList.contains('fixed-tab')) {
                    targetOffsetTop = targetOffsetTop - _this.tabCon.offsetHeight;
                }

                _this.isScrolling = true;
                $('html, body').animate({scrollTop: targetOffsetTop}, 1000, 'linear', function () {
                    _this.isScrolling = false;
                });
                return false;
            }
        }
    },
    // 初始化查看更多
    initCheckMore: function () {
        var _this = this;
        for (var idx = 0; idx < _this.checkMoreList.length; idx++) {
            _this.checkMoreList[idx].index = idx;
            _this.checkMoreList[idx].onclick = function () {
                common.isM ? this.parentElement.parentElement.parentElement.nextElementSibling.classList.add('item-hover') :
                    this.parentElement.parentElement.nextElementSibling.classList.add('item-hover');
            }
        }
        for (var idx = 0; idx < _this.clsoeMoreList.length; idx++) {
            _this.clsoeMoreList[idx].index = idx;
            _this.clsoeMoreList[idx].onclick = function () {
                this.parentElement.parentElement.classList.remove('item-hover')
            }
        }
    },
    /* 滚动定位和固定Tab到顶部 */
    scrollLocate: function () {
        var _this = this;
        var oScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (oScrollTop > _this.tabConTop) {
            _this.tabCon.classList.add('fixed-tab');
            _this.footerCon.classList.remove('hide');
            // !common.getCookie('serverSuccessDialog') && !common.getSS('serverSuccessDialog') &&_this.showDialog();
        } else {
            _this.tabCon.classList.remove('fixed-tab');
            _this.footerCon.classList.add('hide');
        }

        // 滚动完成后再去计算tab选中
        if (!_this.isScrolling) {
            for (var idx = 0; idx < _this.tabList.length; idx++) {
                _this.tabList[idx].parentElement.classList.remove('active-tab');
                var target = document.getElementById(_this.tabList[idx].hash.slice(1));
                if (!target) return;

                // targetTop 目标距离顶部距离，targetBottom 目标底部距离页面顶部距离
                var targetTop = target.offsetTop - 80;
                var targetBottom = target.offsetTop + target.offsetHeight - _this.header.offsetHeight - 10;

                targetTop = targetTop - _this.tabCon.offsetHeight;
                targetBottom = targetBottom - _this.tabCon.offsetHeight;
                if (!_this.tabCon.classList.contains('fixed-tab')) {
                    targetTop = targetTop - 55;
                }

                // 高度容错
                targetTop -= 95;
                targetBottom -= 95;

                if (oScrollTop >= targetTop && oScrollTop < targetBottom) {
                    _this.tabList[idx].parentElement.classList.add('active-tab');
                }

            }
            // tab没有固定之前默认第一个选中
            if (!_this.tabCon.classList.contains('fixed-tab')) {
                _this.tabList[0].parentElement.classList.add('active-tab');
            }
        }
    },

    /* 弹窗 */
    showDialog: function () {
        var _this = this;
        var dialogBoxEl = _this.dialogBoxEl;

        var dialogEl = dialogBoxEl.querySelector('.dialog');
        var maskEl = dialogBoxEl.querySelector('.dialog-mask');
        var confirmEl = dialogBoxEl.querySelector('.dialog-btn');
        var closeEl = dialogBoxEl.querySelector('.dialog-close');

        show();

        common.setSS('serverSuccessDialog', 'true');

        closeEl.addEventListener('click', close);
        maskEl.addEventListener('click', close);
        confirmEl.addEventListener('click', openFile);

        // 判断两秒内是否关闭弹窗
        var timer2 = setTimeout(function () {
            // 判断弹窗是否关闭 jq
            if ($('.new-server-suanli-dialog').css('display') === 'none') {
                var timer15 = setTimeout(function () {
                    campaignPagenewServerModule.showDialog();
                    common.setCookie('serverSuccessDialog', 'true', 365);
                    clearTimeout(timer15);
                }, 15000);
            }
            clearTimeout(timer2);
        }, 2000);

        function show() {
            dialogBoxEl.style.display = 'flex';
            maskEl.classList.remove('dialog-mask-ani-fade-out');
            dialogEl.classList.remove('dialog-ani-to-top'
            );
            maskEl.classList.add('dialog-mask-ani-fade-in');
            dialogEl.classList.add('dialog-ani-from-top');
        }

        function close() {
            maskEl.classList.remove('dialog-mask-ani-fade-in');
            maskEl.classList.add('dialog-mask-ani-fade-out');

            dialogEl.classList.remove('dialog-ani-from-top');
            dialogEl.classList.add('dialog-ani-to-top');

            setTimeout(function () {
                dialogBoxEl.style.display = 'none';
            }, 230);

            closeEl.removeEventListener('click', close);
            maskEl.removeEventListener('click', close);
            confirmEl.removeEventListener('click', openFile);

            gioTrackAction.gio_base('newseverpage_popover_closedClick');
        }

        function openFile() {
            close();
            gioTrackAction.gio_base('newseverpage_popover_receiveClick');
            common.setCookie('serverSuccessDialog', 'true', 365);
            common.gotoUrl(solution_host + '/view-2302270621968415.html');
        }

    }
};

campaignPagenewServerModule.init();

window.onscroll = function () {
    campaignPagenewServerModule.scrollLocate();
};
